import { PureComponent } from 'react';

const VIEWPORT_META_ID = 'hover-react-viewport-meta';
const VIEWPORT_CONTENT =
  'content-width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=0, viewport-fit=cover';

export default class ViewportMeta extends PureComponent {
  componentDidMount() {
    this.metaTag = this.findOrCreateMetaTag();
  }

  componentWillUnmount() {
    this.metaTag.parentNode.removeChild(this.metaTag);
  }

  render() {
    return null;
  }

  findOrCreateMetaTag() {
    let metaTag = document.getElementById(VIEWPORT_META_ID);
    if (metaTag) return metaTag;

    metaTag = document.createElement('meta');
    metaTag.name = 'viewport';
    metaTag.id = VIEWPORT_META_ID;
    metaTag.content = VIEWPORT_CONTENT;
    const head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(metaTag);
    return metaTag;
  }
}
